import { render, staticRenderFns } from "./SlackIcon.vue?vue&type=template&id=77079c42&scoped=true"
import script from "./SlackIcon.vue?vue&type=script&lang=js"
export * from "./SlackIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77079c42",
  null
  
)

export default component.exports